import GlobalActionTypes from "./global.types";

interface GlobalState {
  title: string;
  hasBack: boolean;
  loading: boolean;
  image: string;
  lat: string;
  long: string;
  address: string;
  isNearby: boolean;
  showSuccess: boolean;
  successTitle: string;
  successDesc: string;
  showAlert: boolean;
  alertMessage: string;
  alertType: "error" | "success";
  language: "id" | "en";
}

const INITIAL_STATE: GlobalState = {
  title: "",
  hasBack: false,
  loading: false,
  image: "",
  lat: "",
  long: "",
  address: "",
  isNearby: false,
  showSuccess: false,
  successTitle: "",
  successDesc: "",
  showAlert: false,
  alertMessage: "",
  alertType: "error",
  language: "id",
};

const GlobalReducer = (state = INITIAL_STATE, action: any): GlobalState => {
  switch (action.type) {
    case GlobalActionTypes.SET_HEADER:
      return {
        ...state,
        title: action.payload.title,
        hasBack: action.payload.hasBack,
      };
    case GlobalActionTypes.SHOW_LOADING:
      return {
        ...state,
        loading: true,
      };
    case GlobalActionTypes.HIDE_LOADING:
      return {
        ...state,
        loading: false,
      };
    case GlobalActionTypes.SHOW_SUCCESS:
      return {
        ...state,
        showSuccess: true,
        successTitle: action.payload.title,
        successDesc: action.payload.desc,
      };
    case GlobalActionTypes.HIDE_SUCCESS:
      return {
        ...state,
        showSuccess: false,
        successTitle: "",
        successDesc: "",
      };
    case GlobalActionTypes.SHOW_ALERT:
      return {
        ...state,
        showAlert: true,
        alertMessage: action.payload.alertMessage,
        alertType: action.payload.alertType,
      };
    case GlobalActionTypes.HIDE_ALERT:
      return {
        ...state,
        showAlert: false,
        alertMessage: "",
        alertType: "error",
      };
    case GlobalActionTypes.LANGUAGE:
      return {
        ...state,
        language: action.payload,
      };
    default:
      return state;
  }
};

export default GlobalReducer;
